import {Input} from '@angular/core';

export class BaseDashboardComponent {
    applyFilterSubscription: any;
    @Input() public rowHt?: number;

    constructor() { }

}
